/**
 * ===========================
 * MAIN
 * ===========================
 */
/**
 * Serialise a schema object into the body of a JSON-LD `<script>` tag.
 * `<` is escaped so CMS supplied content holding a literal `</script` cannot
 * close the tag early.
 */
export const serializeJsonLd = (schema: unknown): string => {
  return JSON.stringify(schema).replace(/</g, '\\u003c');
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default serializeJsonLd;
